import { render, staticRenderFns } from "./indexAdminis.vue?vue&type=template&id=0a31123c&scoped=true"
import script from "./indexAdminis.vue?vue&type=script&lang=ts"
export * from "./indexAdminis.vue?vue&type=script&lang=ts"
import style0 from "./indexAdminis.vue?vue&type=style&index=0&id=0a31123c&prod&lang=scss&scoped=true"
import style1 from "./indexAdminis.vue?vue&type=style&index=1&id=0a31123c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a31123c",
  null
  
)

export default component.exports